import { AlignValue, FlexSizeSpecValue, Layout } from '../types/styles';
export const defaultProperties = {
    rootLayout: Layout.Column,
    view: {
        size: {
            width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
            height: { type: 'flex', value: FlexSizeSpecValue.WrapContent },
        },
    },
    box: {
        layout: Layout.Row,
        align: { vertical: AlignValue.Top, horizontal: AlignValue.Left },
    },
};
